import { Component, HostBinding, OnInit } from '@angular/core';

import { ExternalLinkService, SyncService } from './core/services';
import { UserService, AuthenticationService } from 'src/shared/auth';
import { TableFieldService } from './core/services/table-field.service';
import IActiveConnections = Authorization.IActiveConnections;
import { NotificationMessageService } from './core/services/notification-message.service';
import { Router } from '@angular/router';

@Component({
    standalone: false,
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']

})
export class AppComponent implements OnInit {
    @HostBinding('class')
    public readonly hostClass = 'app';

    public activeConnection: IActiveConnections;

    constructor(
        private readonly externalLinkService: ExternalLinkService,
        private readonly userService: UserService,
        private readonly authenticationService: AuthenticationService,
        private readonly tableFieldService: TableFieldService,
        private syncService: SyncService,
        private notificationMessageService: NotificationMessageService,
        private readonly router: Router
    ) {}

    get isAdmin(): boolean {
        return this.router.url.split('/')[1] === `admin`;
    }

    ngOnInit() {
        this.externalLinkService.validateToken();
        this.userService.getUser().subscribe();
        this.authenticationService.getUserFeatures().subscribe();
        this.tableFieldService.getAll().subscribe();
        this.notificationMessageService.getAll().subscribe();
        this.syncService.connectedUsers.subscribe((connectionInfo: IActiveConnections) => {
            this.activeConnection = { ...connectionInfo };
        });
    }
}
